/**
 * isFieldTech(user) — IDI-523 D3: the client copy of the server's viewer rule
 * (backend-go/pkg/viewer IsViewer). One rule, so the UI never
 * shows a field tech what the jobs API strips.
 *
 *   - roles = user.groups when non-empty, else [user.role]
 *   - any field_tech / field_technician → field tech (beats a paid group)
 *   - else any super_admin / idi_admin or paid role → paid
 *   - else (no role, '' or an unknown role such as 'viewer') → field tech
 *   - a user object with no role key and no groups → paid (D3)
 */
const FIELD_TECH = ['field_tech', 'field_technician'];
const PAID = ['super_admin', 'idi_admin', 'admin', 'admin_sales', 'salesperson', 'sales', 'sales_rep'];

const norm = (r) => (typeof r === 'string' ? r.trim().toLowerCase() : '');

export function isFieldTech(user) {
  if (!user || typeof user !== 'object') return false;
  const groups = Array.isArray(user.groups) ? user.groups.filter((g) => norm(g)) : [];
  if (groups.length === 0 && !Object.prototype.hasOwnProperty.call(user, 'role')) return false;
  const roles = (groups.length ? groups : String(user.role ?? '').split(',')).map(norm);
  if (roles.some((r) => FIELD_TECH.includes(r))) return true;
  if (roles.some((r) => PAID.includes(r))) return false;
  return true;
}

/**
 * IDI-582 D2: the pages a field tech may open. Anything else sends them to
 * /jobs (replace, no message).
 */
const FIELD_TECH_PATHS = [
  /^\/jobs\/?$/,
  /^\/jobs\/[^/]+\/?$/,
  /^\/work-orders\/[^/]+\/?$/,
  /^\/calendar\/?$/,
  /^\/customers\/[^/]+\/?$/,
  /^\/profile\/?$/,
  /^\/change-password\/?$/,
  /^\/help(\/.*)?$/,
];

export const FIELD_TECH_HOME = '/jobs';

export function isFieldTechPath(pathname) {
  const p = typeof pathname === 'string' ? pathname : '';
  return FIELD_TECH_PATHS.some((re) => re.test(p));
}

/** IDI-582 S1: where a signed-in user lands. */
export function landingPath(user) {
  return isFieldTech(user) ? FIELD_TECH_HOME : '/dashboard';
}

export default isFieldTech;
